// extracted by mini-css-extract-plugin
module.exports = {"ant-pro-core-label-tip-icon":"ant-pro-core-label-tip-icon","ant-pro-core-label-tip-subtitle":"ant-pro-core-label-tip-subtitle"};